export const usePageStore = defineStore('page', () => {
  const pageType: Ref<'BLOOMREACH' | 'PRODUCT' | 'CATEGORY' | 'SEARCH'> = ref('BLOOMREACH')
  const hrefLangs: Ref<HrefLang[]> = ref([])
  const routeData: Ref<Record<string, any>> = ref({
    type: '',
  })
  const loaded: Ref<boolean> = ref(false)
  const quickFilters: Ref<Array<any>> = ref([])
  const pageData: Ref<Record<string, any>> = ref({})

  return {
    pageType,
    hrefLangs,
    loaded,
    quickFilters,
    routeData,
    pageData,
  }
})

export default usePageStore
